import {watch, reactive, computed} from "vue";

export default () => {
    const recaptchaFields = reactive({
        required: false,
        response: null
    });

    const recaptchaKey = computed(() => {
        return window.recaptchaKey;
    });

    const recaptchaCompleted = (token) => {
        recaptchaFields.response = token;
    };
    const resetCaptcha = () => {

        if (recaptchaFields.response) {
            recaptchaFields.response = '';
            setTimeout(() => {
                this.$refs.recaptcha.reset();
            }, 200);
        }
    };

    const first = (obj) => {
        if (!obj) {
            return null;
        }

        return obj[Object.keys(obj)[0]] ? obj[Object.keys(obj)[0]].toString() : null;
    };

    const firstKey = (obj) => {
        if (!obj) {
            return null;
        }

        return Object.keys(obj)[0];
    };

    // Create a watcher using the watch function
    // First argument: the source of the watch
    // Second argument: the callback function to execute when myValue changes
    watch(() => recaptchaFields.required, (newValue) => {
        if (newValue) {
            setTimeout(() => {
                this.$refs.recaptcha.reset();
            }, 200);
        }
    });

    return {
        recaptchaFields,
        recaptchaKey,
        recaptchaCompleted,
        resetCaptcha,
        first,
        firstKey
    };
}